import { notNull } from './Types';

import { isString } from '@egr/wcf/modules/utils/string';
import { isNumber } from '@egr/wcf/modules/utils/number';
import { isBoolean } from '@egr/wcf/modules/utils/boolean';
import { isArray } from '@egr/wcf/modules/utils/array';
import { isObject } from '@egr/wcf/modules/utils/object';

/** last updated for eaiws 4.10 */
export interface EaiwsImageExportSetting {
    tag?: string;
    width?: number;
    height?: number;
    format: 'SVG' | 'PDF' | 'EPS' | 'PS' | 'JPG' | 'PNG' | 'TGA' | 'TIFF' | 'MCP';
    hideSubArticles?: boolean;
    antialias?: boolean;
    resample?: number;
    quality?: number;
    ambient?: string;
    background?: number;
    enable2D?: boolean;
    enable2DZBuffer?: boolean;
    enable3D?: boolean;
    scale?: number;
    layerControl?: string;
    renderMode?: 'Textures' | 'Color' | 'GrayScale' | 'BlackWhite' | 'PBR'
    outline?: boolean;
    fadeBorder?: number;
    shadowPlane?: boolean;
    'shadowPlane.color'?: string;
    'shadowPlane.smoothness'?: number;
    'shadowPlane.mirror'?: number;
    'shadowPlane.colorMode'?: 'Color' | 'GrayScale';
    'shadowPlane.filter'?: 'Gauss' | 'Linear' | 'Invers' | 'Gauss2' | 'Lightmap' | 'DOF';
    'shadowPlane.border'?: number;
    'shadowPlane.mapSize'?: number;
    'shadowPlane.maxHeight'?: number;
    'shadowPlane.radius'?: number;
    'shadowPlane.intensity'?: number;
    'shadowPlane.samples'?: number;
    projectionMode?: 'Perspective' | 'Orthographic';
    zoom?: number;
    alpha?: number;
    beta?: number;
    margin?: number;
    enableShaders?: boolean;
    'mpc.obx'?: boolean;
    'mpc.comIDs'?: boolean;
    ars?: boolean;
    'ars.camera'?: boolean;
    'ars.lighting'?: boolean;
    'ars.view'?: string;
    osao?: boolean;
    'osao.radius'?: number;
    'osao.intensity'?: number;
    'osao.mapSize'?: number;
    'osao.smoothness'?: number;
    'osao.samples'?: number;
    viewId?: string;
}

export function EaiwsImageExportSettingToOption(setting: EaiwsImageExportSetting): Array<string> {
    return Object.keys(setting).map((key) => {
        const value: string | boolean | number | undefined = setting[key];

        if (isObject(value)) {
            const name: string = key.split('Object')[0];
            return Object.keys(value).map((subKey) =>
                settingAsString(`${name}.${subKey}`, value[subKey])
            ).join(' ');
        }

        return settingAsString(key, value);
    }).filter(notNull);
}

function settingAsString(key: string, value: string | boolean | number | undefined): string | null {
    if (isArray(value)) {
        return `${key}=${value.join(',')}`;
    }

    if (isString(value) || isNumber(value)) {
        return `${key}=${value}`;
    }

    if (isBoolean(value)) {
        return `${key}=${value ? 'true' : 'false'}`;
    }

    return null;
}